import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CampaignClass } from '@feathr/blackbox';
import CampaignSelect from '@feathr/extender/components/CampaignSelect';
import { useCampaignPermissions } from '@feathr/extender/hooks';

import type { ICreativesFilters } from './EventCreativesPage';

import * as styles from './CreativesCampaignSelect.css';

interface IProps {
  eventId: string;
  filters: ICreativesFilters;
  setFilters: (filters: ICreativesFilters) => void;
}

const creativeCampaignTypes = [
  CampaignClass.EmailList,
  CampaignClass.EmailListFacebook,
  CampaignClass.Facebook,
  CampaignClass.Lookalike,
  CampaignClass.SeedSegment,
  CampaignClass.Affinity,
  CampaignClass.MobileGeoFenceRetargeting,
  CampaignClass.MobileGeoFencing,
  CampaignClass.Search,
  CampaignClass.Segment,
  CampaignClass.Omni,
];

function CreativesCampaignSelect({ eventId, filters, setFilters }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const permissions = useCampaignPermissions();

  const permittedCampaignTypes = creativeCampaignTypes.filter((type) => {
    return permissions[type];
  });

  return (
    <CampaignSelect
      className={styles.filter}
      eventId={eventId}
      isMulti={false}
      onChange={(value): void => {
        setFilters({
          ...filters,
          _parent: value ? value : undefined,
        });
      }}
      onClear={(): void => {
        setFilters({ ...filters, _parent: undefined });
      }}
      placeholder={t('Campaign')}
      type={permittedCampaignTypes}
      value={filters._parent ? filters._parent : undefined}
    />
  );
}

export default CreativesCampaignSelect;
